import { CoodeSdk, CoodeSdkOptions, Environments } from '@coode/fe-sdk';

const coodeSdkConfig: CoodeSdkOptions = {
    environment: process.env.VUE_APP_ENVIRONMENT as Environments,
    auth: {
        msal: {
            auth: {
                clientId: process.env.VUE_APP_CLIENT_ID as string,
                authority: process.env.VUE_APP_AUTHORITY_URL as string,
                redirectUri: window.location.origin,
                postLogoutRedirectUri: `${window.location.origin}/authorization/logged-out.html`,
            },
        }
    },
    insights: {
        appInsightsConnectionString: process.env.VUE_APP_APPINSIGHTS_CONNECTION_STRING
    },
    phraseProjectId: process.env.VUE_APP_PHRASE_PROJECT_ID,
    phraseProjectDefaultLanguage: 'en-GB',
};


export const sdk = new CoodeSdk(coodeSdkConfig);
